import { getFileValidityStatus, getStatusText } from './utils';
import { GenericModal } from 'components/Modals/GenericModal';
import { icons } from 'assets/icons/index'
import { alertSuccessMessage } from 'utils/alerts';
import { Vertical } from 'gls';

type FileUploadModalTypes = {
  loading: boolean
  selectedFile: File;
  objectTitle: string;
  onConfirm: () => void;
  onClose: () => void;
};

export default function FileUploadModal(props: FileUploadModalTypes) {
  const {
    selectedFile,
    objectTitle,
    onConfirm,
    onClose,
    loading
  } = props;
  const fileStatus = getFileValidityStatus(selectedFile);
  const fileIsValid = fileStatus === 'valid';

  return (
    <GenericModal
      title={`Bulk ${objectTitle} Upload`}
      roundIconStyle={false}
      icon={fileIsValid
        ? <icons.DownloadIcon aria-label='download' />
        : <icons.ErrorIcon aria-label='error' width="40px" height="40px" />}
      isOpen
      hideCloseButton={loading}
      loading={loading}
      actionName={fileIsValid ? 'Confirm' : ''}
      cancelName={fileIsValid ? 'Cancel' : 'OK'}
      onAction={onConfirm}
      onCancel={() => {
        if (fileIsValid) {
          alertSuccessMessage(`Your file selection has been cancelled`);
          onClose()
        }
        else
          onClose();
      }}
    >
      {!fileIsValid && fileStatus
        ? <span>Sorry, the <b>{selectedFile.name}</b> file could not be uploaded{getStatusText(fileStatus)}</span>
        : <Vertical spacing={20}>
          <span>Please confirm to start the upload and don't close this popup until upload is finished.</span>
          <span><b>{selectedFile.name}</b> file</span>
        </Vertical>
      }
    </GenericModal>
  );
}
